import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useGetRecentUsersQuery } from '../services/dashboard.endpoints';

const RecentUsersTable = () => {
  const { data, error, isLoading } = useGetRecentUsersQuery({
    page: 1,
    limit: 10,
  });
  console.log('RecentUsersTable', error);

  if (isLoading) return <CircularProgress />;
  if (error) return <Typography>Error loading data</Typography>;

  const rows = data?.docs || [];
  const columns = [
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'firstName', headerName: 'First Name', flex: 1 },
    { field: 'lastName', headerName: 'Last Name', flex: 1 },
    { field: 'lastLogin', headerName: 'Last Login', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params: any) => (
        <Button
          variant="contained"
          color="primary"
          href={`#/users/${params.row._id}`}
          target="_blank"
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Box height={300}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.email}
        hideFooterPagination
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default RecentUsersTable;
